(function () {
  'use strict';

  angular
    .module('filter.decimal', [])

    .filter('decimal', function () {
      return function (value) {
        return String(value).replace('.', ',');
      };
    });

})();
